import * as yup from 'yup'

const schema = yup.object().shape({
  categoryId: yup.string().required('Selecione alguma opção'),
  title: yup.string().required().max(80),
  description: yup.string().required().max(255),
})

export default schema
